<template>
<div class="audit-device-pm25-ion-chart">
  <div class="audit-device-pm25-ion-chart-header">
    <!-- 从此之后注释掉 -->
    <site-query v-if="filterSites.length > 0" :sites="filterSites" :query="query" />

    <el-button
      v-if="filterSites.length > 0"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </div>

  <div>
    <x-y-chart
      v-if="dataList[0]"
      :data-config="dataList[0]"
      unit-prop="stdUnit"
      chart-type="bar"
      :stack-type="0"
      data-time-format="HH时"
      download-name="PM2.5和OCEC"
      chart-min-height="300px"
      chart-height="auto"
      style="height:100%;"
    />
  </div>
</div>
</template>

<script>
import XYChart from '../../../../components/DataChart/XYChart'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'

export default {
  name: 'Pm25IonChart',
  components: {SiteQuery, XYChart},
  props: {
    filterSites: {
      required: true,
      type: Array
    },
    query: {
      required: true,
      type: Object
    },
    dataList: {
      required: true,
      type: Array
    }
  },
  methods: {
    onSearchBtnClick () {
      this.$emit('query-site-ids-changed')
    }
  }
}
</script>

<style lang="scss">
.audit-device-pm25-ion-chart {
  display: grid;
  grid-template-rows: max-content auto;
  grid-row-gap: 10px;
  width: 100%;
  height: 100%;

  > * {
    min: {
      width: 100%;
      height: 100%;
    }
  }

  > .audit-device-pm25-ion-chart-header {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/Pm25IonChart.vue